/**
 * Accordion JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Accordion
 */
class Accordion {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        this.accordionHeadings = $( '.js-accordion-heading' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Every heading in the accordion needs to be clickable and
        // when clicked, open the hidden content under it.
        this.accordionHeadings.each( ( index, accordionHeading ) => {
            $( accordionHeading ).on( 'click', ( e ) =>  {
                this.toggleAccordionContent( e, accordionHeading );
            });
        });
    }

    /**
     * This method initializes dynamic accessibility for the accordion.
     * If somehow JS isn't able to load, the accordion is still shown neatly
     * and semantically with dynamic functionality ( opening and closing sections) omitted.
     */
    a11y() {

        this.accordionHeadings.each( ( index, accordionHeading ) => {

            const $accordionHeading = $( accordionHeading );
            const $accordionContent = $accordionHeading.siblings( '.js-accordion-content' );
            const buttonMarkup      = '<button class="js-accordion-button accordion__item__heading-container__button" aria-expanded="false"></button>';
            $accordionContent.addClass( 'js-hidden' );
            $accordionHeading.addClass( 'js-has-button' );
            $accordionHeading.wrapInner( buttonMarkup );
        });
    }

    /**
     * This handles the toggling of the accordion elements' visibility and aria classes.
     *
     * @param {event object} e
     * @param {dom node} accordionHeading
     */
    toggleAccordionContent( e, accordionHeading ) {

        const $accordionHeading       = $( accordionHeading );
        const $accordionContent       = $accordionHeading.siblings( '.js-accordion-content' );
        const $accordionButton        = $accordionHeading.find( '.js-accordion-button' );
        const revertAriaExpandedState = $accordionButton.attr( 'aria-expanded' ) === 'false' ? true : false;

        $accordionHeading.find( '.js-accordion-icon' ).toggleClass( 'rotate-icon' );
        $accordionContent.toggleClass( 'js-hidden' );
        $accordionButton.attr( 'aria-expanded', revertAriaExpandedState );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.a11y();
        this.events();
    }
}

// Export the class reference.
module.exports = Accordion;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/accordion.js